import {
  BASE_URL,
  PERFORMING_FACILITY,
  PERFORMING_FACILITY_DATA,
  ERROR_MSG,
  API_GATEWAY_KEY,
  COPY_TO_SENDING_FACILITY_FLAG,
} from "./Constants";
import Cookies from "js-cookie";

export const getAllPerformingFacilities = async () => {
  let response = await fetch(`${BASE_URL}${PERFORMING_FACILITY}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const fetchPerfFacilitiesData = async (
  pageNo,
  recordsPerPage,
  urlWithParams
) => {
  let response = await fetch(
    `${BASE_URL}${PERFORMING_FACILITY_DATA}/${pageNo}/${recordsPerPage}?${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const addNewPerfFacility = async (form, copyToSendingFacilityFlag) => {
  let response = await fetch(`${BASE_URL}${PERFORMING_FACILITY}${COPY_TO_SENDING_FACILITY_FLAG}${copyToSendingFacilityFlag}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const updatePerfFacilityRecord = async (form) => {
  let response = await fetch(`${BASE_URL}${PERFORMING_FACILITY}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const removePerfFacilityRecord = async (perfFacilityId) => {
  let response = await fetch(
    `${BASE_URL}${PERFORMING_FACILITY}/${perfFacilityId}`,
    {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  if (!response.ok) {
    return ERROR_MSG;
  }
};

export const fetchPerfFacilityById = async (perfFacilityId) => {
  let response = await fetch(
    `${BASE_URL}${PERFORMING_FACILITY}/${perfFacilityId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};
